<template>

<div>
    <el-container style="height: 1200px; border: 1px solid #eee; margin:0 100px 0 100px">
        <el-aside width="200px" style="background-color: rgb(238, 241, 246); height: 200px">
            <h1 class="title">成功案例</h1>
            <hr class="fenge" size="5px" noshade=true/>
            <el-menu default-active="1" class="el-menu-vertical-demo">
                <el-menu-item index="1">
                    <i class="el-icon-s-claim"></i>
                    <span slot="title">案例列表</span>
                </el-menu-item>
            </el-menu>
        </el-aside>
    <el-container> 
    <el-main>
        <p style="margin-bottom: 16px; margin-top: 0px; text-indent: 2em; line-height:30px">多年来，三源风机始终坚持生产工艺不断改进，
            售后服务不断完善，生产的产品以高效、节能、低噪、可靠等优良的性能，深得广大用户单位的好评，在此特表感谢！</p> 
          <el-table :data="tableData" border style="width: 100%">
              <el-table-column prop="date" label="序号" width="90"></el-table-column>
    <el-table-column prop="name" label="项目名称" width="250"></el-table-column>
    <el-table-column prop="address" label="供货产品"></el-table-column>
  </el-table> 
    </el-main>
  </el-container>
</el-container>
</div> 

</template>

<script>
  export default {
    data() {
      return {
        tableData: [{
          date: '1',
          name: '上海首创青浦A-2-4(1)',
          address: '风机、防火阀、风口'
        }, {
          date: '2',
          name: '上海金地新桥项目B地块',
          address: '风机、防火阀、风口'
        }, {
          date: '3',
          name: '腾讯上海(青浦)数据中心',
          address: '风机、防火阀、风口'
        }, {
          date: '4',
          name: '上海泰研通讯设备有限公司',
          address: '风机、防火阀、风口'
        }, {
          date: '5',
          name: '吴猛超医院',
          address: '风机、防火阀、风口'
        }, {
          date: '6',
          name: '武林外滩(钱江杯)',
          address: '风机、防火阀、风口'
        }, {
          date: '7',
          name: '永乐城',
          address: '风机、防火阀、风口'
        }, {
          date: '8',
          name: '三花国际大厦',
          address: '风机、防火阀、风口'
        }, {
          date: '9',
          name: '南京六合社区服务中心',
          address: '风机、防火阀、风口'
        }, {
          date: '10',
          name: '重庆合川江润国际',
          address: '风机、防火阀、风口'
        }, {
          date: '11',
          name: '重庆潼南博雅城',
          address: '风机、防火阀、风口'
        }, {
          date: '12',
          name: '嘉兴晶晖大厦(鲁班奖)',
          address: '风机、防火阀、风口'
        },
        {
          date: '13',
          name: '英冠大酒店项目',
          address: '风机、防火阀、风口'
        }, 
        {
          date: '14',
          name: '杭州萧山信息港项目',
          address: '风机、防火阀、风口'
        }, 
        {
          date: '15',
          name: '临平上坤山新语项目',
          address: '风机、防火阀、风口'
        }, 
        {
          date: '16',
          name: '菜鸟（下沙）项目',
          address: '风机、防火阀、风口'
        }, 
        {
          date: '17',
          name: '嘉兴海纳郡',
          address: '风机、防火阀、风口'
        }, 
        {
          date: '18',
          name: '湖州安吉兰城项目',
          address: '风机、防火阀、风口'
        }, 
        {
          date: '19',
          name: '杭州爱力大厦',
          address: '风机、防火阀、风口'
        }, 
        {
          date: '20',
          name: '更多项目持续更新中',
          address: ' '
        },
        ]
      }
    }
  }
</script>


<style scoped>

.fenge {
    width: 95px;
    margin-top: 0;
    margin-left: 15px;
    background-color: rgb(24, 140, 179);
    border: rgb(24, 140, 179);
    box-shadow: 0 0 0 0;
}

.title {
    font-size: 200%;
    margin-top: 10px;
    margin-bottom: 10px;
    margin-left: 15px;
}
</style>